import React, { useEffect, useMemo, useState } from "react";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import { i18n } from "../../translations/i18n";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../core/feature/language/languageSlice";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CustomApp from "../../core/models/customApp";
import { getCustomApps } from "../../core/service/api";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import { setAndroidAppLanguage } from "./setAppLanguage";
const ComponentChangeLanguage = () => {
  const user: User = useAppSelector((state) => state.user.user);
  let companyStorage = JSON.parse(String(localStorage.getItem("company")));

  const language: String = useAppSelector((state) => state.language.language);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [lang, setLang] = useState(i18n.language);
  const env = Config.BaseUrlDev;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return users;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  useEffect(() => {
    if (lang != language) {
      i18n.changeLanguage(lang);
      dispatch(setLanguage(lang));
      var languageUpper = lang.toUpperCase();

      getCustomApps(companyStorage.id, languageUpper).then((resCustom: any) => {
        console.log(resCustom.data);
        dispatch(setCustomApp(resCustom.data));
      });
      let deviceName = localStorage.getItem("device");
      if (deviceName != null) {
        if (deviceName.includes("android")) {
          // if device is android, call android function
          setAndroidAppLanguage(lang);
        }
        if (deviceName.includes("ios")) {
        }
      }

      toast(t("OTHER.success"));
    }
  }, [lang]);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 transparent`}>
        <TabsMobile
          name={`${t("CHANGE-LANGUAGE.title")}`}
          backUrl={"profile"}
        ></TabsMobile>
      </div>

      <section className="p-8 pt-0">
        <div className="flex mt-4 flex-col">
          <h1 className="text-sm font-medium font-montserrat">
            {t("CHANGE-LANGUAGE.subtitle")}
          </h1>
          <div className="flex flex-col gap-2">
            <div className="flex flex-row gap-2">
              <input
                type="radio"
                name="autoLogin"
                value="id"
                style={{ accentColor: customApp.app_accent_color }}
                id="id"
                checked={lang == "id"}
                onChange={(e) => setLang(e.target.value)}
              />
              <label
                htmlFor="id"
                className="font-montserrat text-sm"
                onClick={() => setLang("id")}
              >
                Indonesia
              </label>
            </div>
            <div className="flex flex-row gap-2">
              <input
                type="radio"
                name="autoLogin"
                value="en"
                id="en"
                style={{ accentColor: customApp.app_accent_color }}
                className="accent-slate-500"
                checked={lang == "en"}
                onChange={(e) => setLang(e.target.value)}
              />

              <label
                htmlFor="eng"
                className="font-montserrat text-sm"
                onClick={() => setLang("en")}
              >
                Inggris
              </label>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComponentChangeLanguage;
